import Model from './model.js';
import FileInfo from './fileInfo.js';

export default class EducationData extends Model
{
    constructor(id, personId, educationalLevel, graduationYear, studyType, shiftType, major, schoolName, educationalInstitution, college, department, admissionChannel, note, file = null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.educationalLevel   = educationalLevel;
        this.graduationYear     = graduationYear;
        this.studyType          = studyType;
        this.shiftType          = shiftType;
        this.major              = major;
        this.schoolName         = schoolName;
        this.educationalInstitution = educationalInstitution;
        this.college            = college;
        this.department         = department;
        this.admissionChannel   = admissionChannel;
        this.note              = note;
        this.file               = file ?? new FileInfo();

        this.init()
    }
    
    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        let educationalLevel = this.educationalLevel?.value;

        let formData = new FormData();
        formData.append('educationalLevel', educationalLevel ?? "");
        formData.append('notes', this.note ?? "");

        // ابتدائية, متوسطة, اعدادية
        if([3, 4, 5, 6, 7, 8].includes(educationalLevel)){
            formData.append('schoolName', this.schoolName ?? "");
        }
        
        // دبلوم, بكالوريوس, دبلوم عالي, ماجستير, دكتوراه
        if([9, 10, 11, 12, 13].includes(Number(educationalLevel))){
            formData.append('department_id', this.department?.value ?? "");
            formData.append('major', this.major ?? "");
            formData.append('admission_channel_id', this.admissionChannel?.value ?? "");
        }

        if (educationalLevel >= 3 && educationalLevel <= 13) {
            formData.append('graduationYear', this.graduationYear ?? "");
            formData.append('studyType', this.studyType?.value ?? "");
            formData.append('shiftType', this.shiftType?.value ?? "");
            if(this.file?.binaryFile) formData.append('file', this.file.binaryFile);
        }
        return formData;
    }

    mapToCreate(){
        let formData = this.mapToUpdate();
        formData.append('person_id', this.personId ?? null);
        
        return formData;
    }
}

